import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '@/config/firebase';
import { useCollaboratorsPublicQuery } from '@/features/Collaborators/Data';

/**
 * Nome de TODO colaborador por id — inclusive quem não está mais ativo (desligado etc.), com
 * "(inativo)". As listas do SI apontam pra ativos de gente que já saiu (ex.: devolução de
 * desligamento, ativo importado do GLPI), e a lista padrão (useCollaboratorsPublicQuery) só
 * traz ACTIVE — o nome sumia ("Colaborador não encontrado").
 */
export function useNomesColaboradores(): Map<string, string> {
  const { data: ativos = [] } = useCollaboratorsPublicQuery();
  const { data: todos = [] } = useQuery({
    queryKey: ['si', 'colaboradores_todos_nomes'],
    queryFn: async () => {
      const snap = await getDocs(collection(db, 'collaborators_public'));
      return snap.docs.map((d) => ({ id: d.id, name: d.data().name as string | undefined, status: d.data().status as string | undefined }));
    },
    staleTime: 10 * 60 * 1000,
  });

  return useMemo(() => {
    const mapa = new Map<string, string>();
    todos.forEach((c) => {
      if (c.name) mapa.set(c.id, c.status === 'ACTIVE' ? c.name : `${c.name} (inativo)`);
    });
    // Ativos em tempo real por cima (nome atualizado na hora).
    ativos.forEach((c) => mapa.set(c.id, c.name));
    return mapa;
  }, [todos, ativos]);
}
